
import { Injectable, Optional } from '@angular/core';
import * as cuba from '@cuba-platform/rest';
import { AbmUtil } from '../Utils/abm-util';
import { AbmConfigService } from './abm-config.service';
import { AbmLoggerService } from './abm-logger.service';

@Injectable({
    providedIn: 'root'
})
export class AbmCubaService {

    public static DEFAULT_APP = 'AbmBE';

    constructor(
        @Optional() private _config: AbmConfigService,
        private _logger: AbmLoggerService) {

        if (this._config) {
            const apiUrl = AbmUtil.formPath(this._config.getBeConfig().api, this._config.getBeConfig().url);
            this._logger.debug('Init default CUBA rest API at:' + apiUrl);
            this.initApp(AbmCubaService.DEFAULT_APP, apiUrl);
        }
    }

    public initApp(name: string, apiUrl: string): cuba.CubaApp {
        if (!name || !apiUrl) {
            throw new Error('Cannot init CUBA app for empty name or API url ');
        }

        let app = cuba.getApp(name);

        if (app) {
            this._logger.warn('Try to create duplicate CUBA app for: ' + name);
            return app;
        }

        app = cuba.initializeApp({ name, apiUrl });

        return app;
    }

    public getApp(name?: string): cuba.CubaApp {
        const appName = name ?? AbmCubaService.DEFAULT_APP;
        const app = cuba.getApp(appName);

        if (!app) {
            throw new Error('No CUBA App for name:' + appName);
        }

        return app;
    }

}
